<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">Sub Brands</h2>
      <div class="flex gap-2">
        <p-button
          label="New Sub Brand"
          icon="pi pi-plus"
          (onClick)="createSubBrand()"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="subBrandName" id="subBrandNameFilter" class="w-full" />
                <label for="subBrandNameFilter">Sub Brand Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="subBrandCode" id="subBrandCodeFilter" class="w-full" />
                <label for="subBrandCodeFilter">Sub Brand Code</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <app-entity-dropdown-picker
            formControlName="brand"
            [adapter]="brandPickerAdapter"
            inputId="brandFilter"
            label="Brand"
            placeholder="Any brand"
            filterPlaceholder="Filter brands"
            columnClass="col-12 md:col-6 lg:col-4"
            addonIconClass="pi pi-tag"
          ></app-entity-dropdown-picker>
        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button" (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table
      #dt
      [value]="subBrands"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadSubBrands($event)"
      dataKey="id"
      styleClass="p-datatable-striped md-data-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="subBrandName">
            Sub Brand Name <p-sortIcon field="subBrandName"></p-sortIcon>
          </th>
          <th pSortableColumn="subBrandCode">
            Sub Brand Code <p-sortIcon field="subBrandCode"></p-sortIcon>
          </th>
          <th>Brand</th>
          <th style="width: 10rem">Actions</th>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-brand>
        <tr>
          <td>{{ brand.subBrandName }}</td>
          <td>{{ brand.subBrandCode ?? null }}</td>
          <td>{{ brand.brand?.brandName ?? '-' }}</td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editSubBrand(brand.subBrandId)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteSubBrand(brand.subBrandId)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Sub Brands found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
